export default __webpack_public_path__ + "static/media/benefit-2@3x.e3a8d0af.png";